import { Trash2, RotateCcw } from "lucide-react";

export function DeletedFilter({ showDeleted, setShowDeleted, deletedCount, testPrefix }) {
  const btn = (active) => `px-4 py-2 text-xs uppercase tracking-[0.15em] border transition-colors ${active ? "border-[#FF4D00] text-[#FF4D00] bg-[#FF4D0010]" : "border-[#2A2A2A] text-[#A1A1AA] hover:text-white"}`;
  return (
    <div className="flex gap-2 mb-4" data-testid={`${testPrefix}-filter`}>
      <button data-testid={`${testPrefix}-filter-active`} onClick={() => setShowDeleted(false)} className={btn(!showDeleted)}>Active</button>
      <button data-testid={`${testPrefix}-filter-deleted`} onClick={() => setShowDeleted(true)} className={`${btn(showDeleted)} inline-flex items-center gap-2`}>
        <Trash2 className="w-3.5 h-3.5" /> Deleted <span data-testid={`${testPrefix}-deleted-count`} className="font-bebas text-base leading-none">{deletedCount}</span>
      </button>
    </div>
  );
}

export function DeletedRowActions({ item, onRestore, onPurge, testPrefix }) {
  return (
    <div className="flex items-center gap-2">
      <button data-testid={`${testPrefix}-restore-${item.id}`} onClick={() => onRestore(item)} className="inline-flex items-center gap-1 border border-[#10B981] text-[#10B981] px-2 py-1 text-xs hover:bg-[#10B98120] transition-colors"><RotateCcw className="w-3.5 h-3.5" /> Restore</button>
      <button data-testid={`${testPrefix}-purge-${item.id}`} onClick={() => onPurge(item)} className="inline-flex items-center gap-1 border border-[#EF4444] text-[#EF4444] px-2 py-1 text-xs hover:bg-[#EF444420] transition-colors whitespace-nowrap"><Trash2 className="w-3.5 h-3.5" /> Delete permanently</button>
    </div>
  );
}

export function DeletedMeta({ item }) {
  return (
    <span className="block text-[11px] text-[#71717A] mt-1 whitespace-nowrap" data-testid={`deleted-meta-${item.id}`}>
      Deleted by {item.deleted_by_name || "admin"} · {item.deleted_at ? new Date(item.deleted_at).toLocaleString() : ""}
    </span>
  );
}

export function RecordSummary({ rows, warning }) {
  return (
    <span className="block">
      {rows.map(([k, v]) => (
        <span key={k} className="flex justify-between gap-4 py-1 border-b border-[#1A1A1A]"><span className="text-[#71717A]">{k}</span><span className="text-white text-right">{v}</span></span>
      ))}
      {warning && <span data-testid="confirm-sent-warning" className="block mt-4 border-l-2 border-[#F59E0B] bg-[#F59E0B10] px-3 py-2 text-[#F59E0B]">{warning}</span>}
    </span>
  );
}
